if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
       
        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

    onSubmitHandler(evt) {
    evt.preventDefault();
    if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

    this.handleErrorMessage();

    
     if (document.body.querySelector('.product_kev .show_unavailable_variant_kev')) {

    }else{
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');
    }

    var checkedRadioButton = document.querySelector('input[name="bundle_product"]:checked');
    var checkedRadioButton_a = document.querySelector('input[name="bundle_product_second"]:checked');
     var checkedRadioButton_b = document.querySelector('input[name="bundle_product_third"]:checked');
    let selectedVarValue = null;
    let selectedVarValue_a = null;
    let selectedVarValue_b = null;
    if (checkedRadioButton) {
        selectedVarValue = checkedRadioButton.getAttribute('selected_var');
        console.log('Selected Var Value:', );
    }
     if (checkedRadioButton_a) {
        selectedVarValue_a = checkedRadioButton_a.getAttribute('selected_var');
        console.log('Selected Var Value:', );
    }
     if (checkedRadioButton_b) {
        selectedVarValue_b = checkedRadioButton_b.getAttribute('selected_var');
        console.log('Selected Var Value:', );
    }
    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    const formData = new FormData(this.form);
    
      if (selectedVarValue) {
          formData.append('items[0][id]', selectedVarValue);
          formData.append('items[0][quantity]', 1);
      }
      if (selectedVarValue_a) {
          formData.append('items[1][id]', selectedVarValue_a);
          formData.append('items[1][quantity]', 1);
      }
      if (selectedVarValue_b) {
          formData.append('items[2][id]', selectedVarValue_b);
          formData.append('items[2][quantity]', 1);
      }


    if (this.cart) {
        formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
        );
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
    }
    config.body = formData;

    fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
            if (response.status) {
                publish(PUB_SUB_EVENTS.cartError, {
                    source: 'product-form',
                    productVariantId: formData.get('id'),
                    errors: response.errors || response.description,
                    message: response.message,
                });
                this.handleErrorMessage(response.description);

                const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
                if (!soldOutMessage) return;
                this.submitButton.setAttribute('aria-disabled', true);
                this.submitButton.querySelector('span').classList.add('hidden');
                soldOutMessage.classList.remove('hidden');
                this.error = true;
                return;
            } else if (!this.cart) {
                window.location = window.routes.cart_url;
                return;
            }

            if (!this.error)
                publish(PUB_SUB_EVENTS.cartUpdate, {
                    source: 'product-form',
                    productVariantId: formData.get('id'),
                    cartData: response,
                });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
                document.body.addEventListener(
                    'modalClosed',
                    () => {
                        setTimeout(() => {
                            this.cart.renderContents(response);
                            countdown("ten-countdown", 10, 0);
                        });
                    },
                    { once: true }
                );
                quickAddModal.hide(true);
            } else {
                this.cart.renderContents(response);
                countdown("ten-countdown", 10, 0);
            }
        })
        .catch((e) => {
            console.error(e);
        })
        .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
        });
}
      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}



 if (document.body.querySelector('.product_kev .show_unavailable_variant_kev')) {
    const fallbackBtn_new = document.querySelector('.ctm-product-form__submit');
    fallbackBtn_new.addEventListener('click', function () {
    // Add loading state
    this.classList.add('loading');
    $(this).find('.loading__spinner').removeClass('hidden');

    // Remove loading after 2 seconds
    setTimeout(() => {
        this.classList.remove('loading');
        $(this).find('.loading__spinner').addClass('hidden');

    }, 2000);
    });
} 